import React from 'react';
import { motion } from 'framer-motion';
import { Globe2, Calculator, Briefcase, Users, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
const services = [{
  id: 'movilidad',
  title: 'Movilidad Internacional',
  description: 'Gestión completa de visados, permisos de residencia y trabajo para empleados y particulares.',
  icon: <Globe2 className="w-8 h-8 text-primary" data-id="element-280" />,
  features: ['Visados de trabajo', 'Permisos de residencia', 'Reagrupación familiar']
}, {
  id: 'fiscalidad',
  title: 'Contabilidad y Fiscalidad',
  description: 'Asesoramiento fiscal integral para optimizar la carga tributaria de tu empresa o patrimonio.',
  icon: <Calculator className="w-8 h-8 text-indigo" data-id="element-281" />,
  features: ['Impuestos corporativos', 'Declaraciones trimestrales', 'Planificación fiscal']
}, {
  id: 'mercantil',
  title: 'Asesoría Mercantil',
  description: 'Constitución de sociedades, modificaciones estatutarias y secretaría corporativa.',
  icon: <Briefcase className="w-8 h-8 text-steel" data-id="element-282" />,
  features: ['Creación de empresas', 'Pactos de socios', 'Compliance legal']
}, {
  id: 'laboral',
  title: 'Asesoría Laboral',
  description: 'Gestión de nóminas, contratos y seguridad social con total cumplimiento normativo.',
  icon: <Users className="w-8 h-8 text-navy" data-id="element-283" />,
  features: ['Altas y bajas SS', 'Contratación', 'Prevención riesgos']
}];
export function Services() {
  return <section id="services" className="py-20 bg-surface" data-id="element-284">
      <div className="container mx-auto px-4 md:px-6" data-id="element-285">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-286">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-287">
            Soluciones integrales para tu tranquilidad
          </h2>
          <p className="text-lg text-gray-600" data-id="element-288">
            Cubrimos todas las necesidades legales y administrativas para que
            puedas operar en España sin preocupaciones.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-289">
          {services.map((service, index) => <motion.div key={service.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow border border-gray-100 flex flex-col h-full group" data-id="element-290">
              <div className="mb-6 p-3 rounded-xl bg-gray-50 w-fit group-hover:scale-110 transition-transform duration-300" data-id="element-291">
                {service.icon}
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-292">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6 flex-grow text-sm leading-relaxed" data-id="element-293">
                {service.description}
              </p>

              <ul className="space-y-2 mb-6" data-id="element-294">
                {service.features.map((feature, i) => <li key={i} className="flex items-center text-xs text-gray-500" data-id="element-295">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary mr-2" data-id="element-296"></span>
                    {feature}
                  </li>)}
              </ul>

              <Button variant="secondary" size="sm" className="w-full justify-between group-hover:bg-primary group-hover:text-white group-hover:border-primary transition-all" rightIcon={<ArrowRight className="w-4 h-4" data-id="element-298" />} onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-297">
                Solicitar presupuesto
              </Button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}